import script from "./DataErrorSubmission.vue?vue&type=script&lang=ts&setup=true"
export * from "./DataErrorSubmission.vue?vue&type=script&lang=ts&setup=true"

import "./DataErrorSubmission.vue?vue&type=style&index=0&id=1fc511e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fc511e4"]])

export default __exports__